import { CommonModule } from '@angular/common';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { TableModule } from 'primeng/table';
import { TramActividadService } from '../../../../services/database/tramActividad.service';
import { IGetMisTramites } from '../../../../shared/interfaces/database/tramite';
import { TramiteHistorialActividadComponent } from './tramite-historial-actividad/tramite-historial-actividad.component';
import { AccessRole, ButtonColumnType, CustomTableComponent, DataColumnType, ICustomTable, LocalService,DATE_WITH_HOUR_FORMAT } from 'lib-base';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { firstValueFrom, forkJoin } from 'rxjs';
@Component({
  selector: 'app-tramites-historial',
  standalone: true,
  imports: [
    CommonModule, TranslateModule, CustomTableComponent,
    TableModule, ButtonModule, TramiteHistorialActividadComponent,
  ],
  template:`
    <custom-table [config]="customTable" [rowExpansionTemplate]="tableRowexpansion">
    </custom-table>
    <ng-template #tableRowexpansion let-data>
      <app-tramite-historial-actividad [tramRegistroId]="data.id"
                                      class="app-card mx-auto border-1 border-top-none border-noround-top"/>
    </ng-template>
  `
})
export class TramitesHistorialComponent implements OnInit {
  @Input() tramEstados: string[] = [];
  @Input() tramActividadEstados: string[] = [];
  trans: any = {};
  customTable !: ICustomTable;
  @ViewChild(CustomTableComponent) customTableComponent !: CustomTableComponent;
  role = AccessRole;


  constructor(private readonly _tas: TramActividadService, private readonly _t: TranslateService, private readonly _ls: LocalService) {
  }

  ngOnInit(): void {
    this.translate().then(() => this.configureTable());
  }

  private async translate(): Promise<void> {
    this.trans = await firstValueFrom(forkJoin({
      radicado: this._t.get('common.radicado'),
      tipoDeTrámite: this._t.get('common.tramite'),
      observaciones: this._t.get('common.observaciones'),
      estado: this._t.get('common.estado'),
      fechaActualización: this._t.get('common.fechaActualización'),
      fechaSolicitud: this._t.get('common.fechaSolicitud'),
      dependencia: this._t.get('common.dependencia'),
      semaforoDeCumplimiento: this._t.get('common.semaforoDeCumplimiento'),
    }));
  }

  private configureTable() {
    const indicadorActivo: boolean = this.tramEstados.includes('ACTIVO');

    this.customTable = {
      columns: [
        {
          field: 'expand',
          header: '',
          class:'p-button-info',
          width: '0.5rem',
          buttonType: ButtonColumnType.EXPANDED
        },
        {
          field: 'tiposTramiteDescripcion',
          header: this.trans.tipoDeTrámite,
          class:'font-13',
          width: '22em',
          columnmHeader: {
            class:'text-left color-blue-2 font-13 font-bold',
            style:''
          },
          sort: true,
          columnFilter: true,
          dataType: DataColumnType.TEXT
        },
        {
          field: 'dependencia',
          header: this.trans.dependencia,
          sort: true,
          width: '17rem',
          class:'brand-table-tag mx-auto my-auto font-13',
          columnmHeader: {
            class:'text-left color-blue-2 font-13 font-bold',
            style:''
          },
          columnFilter: true,
          dataType: DataColumnType.TEXT
        },
        {
          field: 'radicado',
          header: this.trans.radicado,
          sort: true,
          columnFilter: true,
          dataType: DataColumnType.TEXT,
          class:'font-13',
          columnmHeader: {
            class:'text-left color-blue-2 font-13 font-bold',
            style:''
          },
        },
        {
          field: 'observaciones',
          class:'font-13',
          width: "15em",
          columnmHeader: {
            class:'text-left color-blue-2 font-13 font-bold',
            style:''
          },
          header: this.trans.observaciones,
          dataType: DataColumnType.TEXT
        },
        {
          field: 'tramiteEstado',
          header: this.trans.estado,
          sort: true,
          columnmHeader: {
            class:'text-left color-blue-2 font-13 font-bold',
          },
          columnFilter: true,
          dataType: DataColumnType.ESTADO_TAG,
        },
        {
          field: indicadorActivo ? 'rangoIndicadorInicial' : 'rangoIndicadorFinal',
          header: this.trans.semaforoDeCumplimiento,
          sort: true,
          columnmHeader: {
            class:'text-left color-blue-2 font-13 font-bold',
          },
          columnFilter: true,
          dataType: DataColumnType.TAG,
          getStyle: (data: IGetMisTramites) => {
            const color = data.tramiteEstado === 'ACTIVO' ? data.rangoColorInicial : data.rangoColorFinal;
            return {
              'background-color': color
            };
          }
        },
        {
          field: 'fechaActualizacion',
          header:  this.trans.fechaActualización,
          width: "5rem",
          class:'font-12',
          columnmHeader: {
            class:'text-left color-blue-2 font-12 font-bold',
            style:{ 'text-wrap': 'auto' }
          },
          format:DATE_WITH_HOUR_FORMAT,
          dataType: DataColumnType.DATE,
        },
        {
          field: 'fechaSolicitud',
          header: this.trans.fechaSolicitud,
          sort: true,
          width: "5rem",
          class:'font-12',
          columnmHeader: {
            class:'text-left color-blue-2 font-12 font-bold',
            style:{ 'text-wrap': 'auto' }
          },
          format:DATE_WITH_HOUR_FORMAT,
          dataType: DataColumnType.DATE,
        },
      ],
      settings: {
        table: {
          rows: 8
        }
      }
    } as ICustomTable;
  }

  getMisTramites() {
    this._tas.getMisTramites(this.tramEstados, this.tramActividadEstados).subscribe({
      next: (data: IGetMisTramites[]) => {
        this.customTableComponent.data = data;
      }
    });
  }
}
